import ConfigManager from "components/config/ConfigManager"
import { ELENCHI } from "configuration/ConfigurazioneElenchi"
import Breadcrumbs from '../Breadcrumbs'
import { FRONTOFFICE_CONDIVISO } from 'configuration/frontoffice'

export default function BreadcrumbsFrontOffice({ conf = null }) {
  // Se conf è già fornito, lo usiamo direttamente
  if (conf) {
    return <Breadcrumbs sx={{ mb: 3 }} {...conf} />
  }

  // Altrimenti, utilizziamo ConfigManager e renderizziamo BaseBreadcrumbs solo quando i dati sono pronti
  return (
    <ConfigManager elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_CONDIVISO]}>
      {propsConfig => <Breadcrumbs {...(propsConfig.val(FRONTOFFICE_CONDIVISO.BREADCRUMBS) ?? null)} />}
    </ConfigManager>
  )
}